import React, { useState } from 'react';
import { LabeledInput, CheckBox } from '../../../Components';
import './Index.css';
const Index = ({ gst }) => {
    const [printCost, setPrintCost] = useState(60);
    const [neckLabelPrice, setNeckLabelPrice] = useState(7);
    const [hasaNeckLabel, setNeckLabel] = useState(false);
    const neckLabelCheckhandler = (name, currentState) => {
        setNeckLabel(!currentState);
    };

    let price = 150 + 50 + printCost;
    if (hasaNeckLabel) {
        price += neckLabelPrice;
    }

    price += price * (parseFloat(gst) / 100);
    return (
        <div className="pricing_body_sublimationprint">
            <div className="home_head">
                <h2 className="home_heading"> Sublimation Printing</h2>
            </div>
            <div>
                <div>
                    <p>
                        <span>TShirt Price:</span> 150₹
                    </p>
                    <p>
                        <span>Delivery Cost:</span> 50₹
                    </p>
                    <p>
                        <span>Printing Type:</span> Sublimation Printing
                    </p>

                    <p>
                        <span>
                            Sublimation print will always has a max of A4 size printing with fix Price of {printCost}₹.
                        </span>
                    </p>
                    <CheckBox
                        style={{ marginBottom: '0' }}
                        handleChange={neckLabelCheckhandler}
                        name="isNeckLabel2"
                        value="isNeckLabel2"
                        labeling="has a Neck Label?"
                        checked={false}
                    />
                    <p style={{ marginBottom: '2rem' }} className="input_info">
                        Neck Label has fix price {neckLabelPrice}₹
                    </p>
                    <p>
                        <span>Total Price (inclusive of shipping and {gst}% GST):</span> {price}₹
                    </p>
                </div>
                <div>
                    <p>
                        <span>Set Pricing Values</span>
                    </p>
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        type="number"
                        label="Print Cost ₹"
                        name="Width"
                        value={printCost}
                        changeHandler={(e) => {
                            setPrintCost(e.target.value);
                        }}
                    />
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        type="number"
                        label="Neck Label Price ₹"
                        name="necklabel"
                        value={neckLabelPrice}
                        changeHandler={(e) => {
                            setNeckLabelPrice(e.target.value);
                        }}
                    />
                    <button className="btn-orange">Update Values</button>
                </div>
            </div>
        </div>
    );
};

export default Index;
